@let hasPrefix = prefix() || iconPrefix() || currencyPrefix();
@if (skeleton()) {
  <lib-skeleton-loader [theme]="{
          'height.px': screen() === 'mobile' ? 44 : 32,
          'width.%': 100
  }"></lib-skeleton-loader>
} @else {
<section class="flex items-center w-full">
  @if (hasPrefix) {
  <div
    class="content-regular text-muted-foreground leading-6 bg-muted-solid border-1 border-border-solid px-[9px] rounded-l-[8px] flex items-center"
    [ngClass]="{
      'opacity-50' : effectiveState() === 'disabled',
      'h-[44px]': screen() === 'mobile',
      'h-[32px]': screen() === 'desktop',
      }">
    @if (iconPrefix()) {
      <i class="fi fi-rr-{{ iconPrefix() }} text-[16px] block h-[16px] mt-[-5px]"></i>
    }
    @if (svgPrefix()) {
      <lib-system-icons class="max-w-[20px] max-h-[20px]" [iconName]="svgPrefix()"/>
    }
    @if (prefix()) {
    <span class="px-[7px]">{{ prefix() | translate }}</span>
    }
    @if (currencyPrefix()) {
      <span class="px-[7px]">{{ formattingService.getCurrencySymbol() }}</span>
      }
  </div>
  }
  <div class="relative flex-1 flex items-center" [ngClass]="effectiveState()">
    @if (icon()) {
    <button type="button" class="p-[2px] w-[20px] h-[20px] absolute rounded-md disabled:opacity-50 text-muted-foreground
    focus-visible:outline-1 focus-visible:outline-primary focus-visible:outline-offset-1 focus-visible:outline"
      [ngClass]="{
      'left-[10px]': iconAlign() === 'left',
      'right-[10px]': iconAlign() === 'right',
      'cursor-pointer hover:text-foreground': clickableIcon(),
      'cursor-text': !clickableIcon(),
    }"
    [attr.tabindex]="-1"
    [disabled]="effectiveState() === 'disabled'"  (click)="clickIcon()">
      <i [ngClass]="iconColor()" class="fi fi-rr-{{ icon() }} text-[16px] block h-[16px] mt-[-5px]"></i>
    </button>
    }

    <input #inputElement class="{{ fontToken() }} w-full leading-[24px] text-foreground placeholder:text-muted-foreground
      disabled:opacity-50 bg-background focus:ring-0 border-1 focus:border-transparent flex items-center text-{{alignment()}}" [ngClass]="{
      '!text-right enabled:hover:!border-border-solid enabled:hover:border-1 !border-transparent !border-radius-6 enabled:hover:dropshadow-xs': styleType() === 'comboBoxDate' && !isComboBoxDateOpen(),
      '!text-right border-border-solid !border-1 !border-radius-6' :  styleType() === 'comboBoxDate' && isComboBoxDateOpen(),
      'h-[44px]': screen() === 'mobile',
      'h-[32px]': screen() === 'desktop',
      'px-[10px] !text-center': squareInput(),
      'px-[17px]': !squareInput(),
      'pl-[37px]': icon() && iconAlign() === 'left',
      'pr-[37px]': icon() && iconAlign() === 'right',
      'border-danger focus:outline-danger': effectiveState() === 'error' && withBorder(),
      'border-success focus:outline-success': effectiveState() === 'success' && withBorder(),
      'border-border-solid focus:outline-primary': effectiveState() !== 'error' && effectiveState() !== 'success' && withBorder(),
      'border-radius-6 focus:outline-1 focus:-outline-offset-1 focus:outline': withBorder(),
      'dropshadow-xs': styleType() !== 'ghost' && withBorder(),
      '!rounded-r-none border-r-0 pr-0': suffix()|| iconSuffix(),
      '!rounded-l-none border-l-0': hasPrefix,
      'focus:outline-none': !withBorder(),
      'border-transparent': !withBorder() || (styleType() === 'ghost' && effectiveState() === 'default'),
      'focus:!bg-background hover:!bg-accent-transparent focus-visible:bg-accent-transparent': styleType() === 'ghost' && effectiveState() === 'default',
      '!bg-transparent': transparent(),
      'line-through !text-muted-foreground': lineThrough(),
    }"
      [ngModel]="type() === 'currency' || type() === 'currency-without-symbol' ? displayValue : _value"
      (ngModelChange)="onModelChange($event)"
      [type]="type() === 'currency' || type() === 'currency-without-symbol' ? 'text' : type()"
      [placeholder]="(placeholder() || '') | translate "
      [required]="required()"
      [autocomplete]="autocomplete()" [readOnly]="readOnly()" [disabled]="effectiveState() === 'disabled'" [mask]="mask()" [leadZeroDateTime]="leadZeroDateTime()"
      [specialCharacters]="specialCharacters()" [dropSpecialCharacters]="dropSpecialCharacters()" (blur)="barred()"
      [maxlength]="maxLength()"
      [attr.id]="id() ? id() : null"
      (focus)="onFocus($event)"
      (input)="onInput($event)"
      (keydown)="onKeyDown($event)"
      (paste)="onPaste($event)"
      [attr.size]="fitContent() ? (inputElement.value?.toString()?.length || 1) : 'auto'"
      [suffix]="maskSuffix()"
      />
  </div>

  @if (suffix() || iconSuffix()) {
  <div
    class="content-regular text-muted-foreground leading-6 bg-muted-solid border-1 border-border-solid px-[9px] rounded-r-[8px] flex items-center"
    [ngClass]="{
      'opacity-50' : effectiveState() === 'disabled',
      'h-[44px]': screen() === 'mobile',
      'h-[32px]': screen() === 'desktop',
      }">
    @if (suffix()) {
    <span class="px-[7px]">{{ suffix() | translate }}</span>
    }
    @if (iconSuffix()) {
    <i class="fi fi-rr-{{ iconSuffix() }} text-[16px] block h-[16px] mt-[-5px]"></i>
    }
  </div>
  }
</section>
}
